import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { ROUTES } from "constants/routes";
import { Link, useNavigate } from "react-router-dom";
import { addItemToCart } from "slices/cartReducer";
import { handleSnackBar } from "slices/global";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { checkAddToCartAllow, checkHasAddedToCart } from "utils/cart.util";

const CustomChip = ({ label, val }: any) => (
  <Chip
    sx={{ background: "#F4F4F4" }}
    label={
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1.5}
      >
        <Typography
          sx={{
            fontSize: "13px",
            color: "#323232",
            fontWeight: 500,
            lineHeight: "16px",
          }}
        >
          {label} :
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            color: "#323232",
            fontWeight: 500,
            lineHeight: "16px",
          }}
        >
          {val}
        </Typography>
      </Stack>
    }
  />
);
const SearchListCardItem = ({
  listing_name,
  images,
  id,
  horse_power,
  offer_delv_pickup,
  price,
  background,
  user_id,
  has_pto,
  listing_type,
  capacity,
  capacity_unit,
  approval_policy_type,
}: any) => {
  const { authReducer, cartReducer }: any = useAppSelector((state) => state);
  const navigation = useNavigate();
  const dispatch = useAppDispatch();
  const isAddedToCart = checkHasAddedToCart({ id }, cartReducer?.items ?? []);

  const addTocart = () => {
    if (!authReducer.isLoggedIn) navigation(`${ROUTES.SIGNIN}`);

    // call API
    if (authReducer.isLoggedIn) {
      dispatch(addItemToCart({ id: id }));
    } else {
      navigation(`${ROUTES.SIGNIN}`);
    }
  };

  return (
    <Card
      sx={{ borderRadius: 0, height: "100%", background: background ?? "#FFF" }}
      elevation={0}
    >
      <Link
        to={ROUTES.LISTING_DETAIL.replace(":id", id)}
        style={{ textDecoration: "none" }}
      >
        <CardMedia
          sx={{
            height: {
              md: "256px",
              lg: "256px",
              xl: "256px",
              sm: "130px",
              xs: "130px",
            },
            width: "100%",
            borderRadius: "10px",

            backgroundPosition: "center",
          }}
          image={images[0]?.preview_url}
          title={listing_name}
        >
          <Box
            sx={{
              py: "10px",
              px: "10px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {/* <Box
              sx={{
                height: "32px",
                width: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",

                background: "#F1B724",
                borderRadius: "20px",
                gap: "5px",
              }}
            >
              <img
                alt=""
                src="/assets/img/icons/star.svg"
                width="16px"
                height="16px"
              />
              <Typography
                sx={{
                  color: "#FFF",
                  fontSize: "14px",
                  fontWeight: 500,
                }}
              >
                {rating}
              </Typography>
            </Box> */}
          </Box>
        </CardMedia>
      </Link>
      <CardContent sx={{ padding: "10px 0px" }}>
        <Grid
          container
          spacing={1}
          onClick={() => navigation(ROUTES.LISTING_DETAIL.replace(":id", id))}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#323232",

                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",

                // height: "55px",
              }}
            >
              {listing_name}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Stack
              spacing={1}
              direction="row"
              useFlexGap
              overflow="auto"
              //   flexWrap="wrap"
              sx={{
                flexWrap: {
                  md: "wrap",
                  lg: "wrap",
                  xl: "wrap",
                  sm: "nowrap",
                  xs: "nowrap",
                },
                height: {
                  md: "73px",
                  lg: "73px",
                  xl: "73px",
                  sm: "33px",
                  xs: "33px",
                },
                "::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {listing_type === 2 && (
                <>
                  <CustomChip
                    label="Capacity"
                    val={`${capacity} ${capacity_unit}`}
                  />

                  <CustomChip
                    label={`Booking Type`}
                    val={approval_policy_type === 2 ? "Instabook" : "Manual"}
                  />
                  <CustomChip
                    label={`Service Offered`}
                    val={offer_delv_pickup ? "Delivery" : "Pickup"}
                  />
                </>
              )}
              {listing_type === 1 && (
                <>
                  <CustomChip label="HP" val={horse_power} />

                  <CustomChip
                    label={`Booking Type`}
                    val={approval_policy_type === 2 ? "Instabook" : "Manual"}
                  />
                  <CustomChip
                    label={`Service Offered`}
                    val={offer_delv_pickup ? "Delivery" : "Pickup"}
                  />
                </>
              )}
            </Stack>
          </Grid>
        </Grid>
        <Box
          sx={{
            mt: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: 600,
              lineHeight: "31px",
              color: "#323232",
            }}
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              currencyDisplay: "narrowSymbol",
            }).format(price)}
            /
            <Typography
              component="span"
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                lineHeight: "31px",
                color: "#323232",
              }}
            >
              Day
            </Typography>
          </Typography>

          <Button
            variant="contained"
            sx={{
              height: "48px",
              fontWeight: 500,
              fontSize: "15px",
              borderRadius: "10px",

              display: {
                lg: "block",
                xl: "block",
                md: "block",
                sm: "none",
                xs: "none",
              },
            }}
            disabled={cartReducer?.addingToCartId === id || isAddedToCart}
            onClick={() =>
              checkAddToCartAllow({
                data: { id, user_id: user_id || 0 },
                allItems: cartReducer?.items ?? [],
                callback: () => addTocart(),
                onError: (message: string) => {
                  dispatch(
                    handleSnackBar({
                      message,
                      open: true,
                      severity: "error",
                    })
                  );
                },
              })
            }
          >
            Add to Cart
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SearchListCardItem;
